import { Monoid } from '~/util/helpers/monoid'

export type Price = {
  withTax: number
  withoutTax: number
}

export const zero: Price = {
  withTax: 0,
  withoutTax: 0,
}

export function rounded(price: Price): Price

export function rounded(price: number): number

export function rounded(price: number | Price): number | Price {
  if (typeof price === 'number') {
    return parseFloat((Math.round(price * 100) / 100).toFixed(2))
  }
  return {
    withTax: rounded(price.withTax),
    withoutTax: rounded(price.withoutTax),
  }
}

export const append = (left: Price, right: Price): Price => ({
  withTax: rounded(left).withTax + rounded(right).withTax,
  withoutTax: rounded(left).withoutTax + rounded(right).withoutTax,
})

export const multiply = (price: Price, factor: number) => ({
  withTax: rounded(price).withTax * factor,
  withoutTax: rounded(price).withoutTax * factor,
})

export const monoid: Monoid<Price> = {
  zero,
  append,
}

export function cheapestBy<A>(xs: A[], fn: (x: A) => Price): A {
  if (xs.length === 0) {
    throw new Error('cheapestBy expects a non empty options array')
  }
  const cheapest = (left: A, right: A): A => (fn(left).withTax <= fn(right).withTax ? left : right)
  return xs.reduce(cheapest)
}

export const cheapest = (prices: Price[]): Price => cheapestBy(prices, (price) => price)
